import { render, staticRenderFns } from "./BgStateModal.vue?vue&type=template&id=a845b674"
import script from "./BgStateModal.vue?vue&type=script&lang=js"
export * from "./BgStateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports